import React from 'react'

const AboutPage = () => {
  return (
    <div>
       <h1 className='ms-2 mt-2 fs-2'>About Us</h1>
       <h2 className='ms-2 mt-2 fs-5'>This is Groceries! You're one stop shop to manage your grocery data, expiration dates, and your recipes.</h2>
       <h2 className='ms-2 mt-2 fs-5'> I built this app because everytime I bought groceries they would expire without me knowing! <br/>
       I realized that I needed something that allowed me to manage my groceries and that gave me a visual. </h2>
       <h2 className='ms-2 mt-2 fs-5'> So I hope this is as useful to you as it is to me ! </h2>
    </div>
  )
}

export default AboutPage


